// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__sadND","loader":"Loader_loader__DwtSp","load":"Loader_load__GV44D","content":"Loader_content__nFjf0","process":"Loader_process__Y690W"};